import React, { useEffect, useState } from 'react';
import { WarningIcon } from './Icons';
export const UrgencyBar = () => {
  // Start at 12:45:00 in seconds (12 * 3600 + 45 * 60)
  const [timeLeft, setTimeLeft] = useState(45900);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <div className="sticky top-0 z-50 bg-brand-crimson text-white py-3 px-4 shadow-md" data-id="element-207">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-center gap-2 md:gap-4 text-center text-sm md:text-base font-medium" data-id="element-208">
        <div className="flex items-center gap-2" data-id="element-209">
          <WarningIcon className="w-5 h-5 flex-shrink-0" data-id="element-210" />
          <span data-id="element-211">
            ATENCIÓN: La oferta de lanzamiento con 15 Bonos de Regalo expira
            cuando el contador llegue a cero.
          </span>
        </div>
        <div className="font-bold bg-white/20 px-3 py-1 rounded-md tracking-wider" data-id="element-212">
          [{formatTime(timeLeft)}]
        </div>
      </div>
    </div>;
};